<template>
    <div class="ut-container-lg">
        <div class="page-heading">
            <h1>Contact us</h1>
        </div>
        <div class="ut-flex ut-flex-row ut-items-start ut-content-start ut-text-center">
            <div class="">
                <address>
                    OpenAgent Pty Ltd<br>
                    PO Box 419, Alexandria NSW 1435
                </address>
                <p>ABN 93161595679</p>
                <p>Call us on <a href="tel:+61132434">13 24 34</a></p>
                <p>Email us on <a href = "mailto:agents@openagent.com.au" class="ga-event" data-category="Contact Us">agents@openagent.com.au</a></p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ContactUs',
  props: [
  ],
  computed: {
  },
};
</script>

<style scoped>

address {
    padding: 10px;
    line-height: 25px;
}

p {
    padding: 3px;
}

</style>
